<template>
    
</template>

<script>
    export default {
        name: "simple-weekly-schedule-day"
    }
</script>

<style scoped>

</style>